import { getFirstPhoneItemInCart } from "./cartSelectors";
import { RootState } from "../../../../../models";
import { CheckoutState, SubscriptionsState } from "../../../../../models/state";

export type State = Pick<RootState, "checkout">;
export const getCheckout = (state: State): Partial<CheckoutState> => state.checkout || {};

/** @deprecated use getSubscriptions in subscriptionSelectors */
export const getCheckoutSubscriptions: (state: State) => SubscriptionsState = (state) =>
    getCheckout(state).subscriptions || {};

// TODO: Move to subscriptionSelectors
export const cartItemId: (state: State) => string | undefined = (state) =>
    Object.keys(getCheckoutSubscriptions(state))[0] || undefined;

export const cartItemIdToAddOnboardingService: (state: State) => string | undefined = (state) => {
    // we are going to add the onboarding service only to the first handset in the cart
    // if we get insight of this is a success => we should add service to each handset

    const firstItem = getFirstPhoneItemInCart(state);
    return firstItem?.bundleId || firstItem?.cartItemId;
};
